import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdministrator?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdministrator = false }) => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-gray-600">{t('status.loadingEllipsis')}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdministrator && user?.systemRole !== 'Administrator' && user?.email !== 'minguva@hotmail.com') {
    // Privileged routes stay deny-by-default until the user's administrator role is confirmed.
    return <Navigate to="/trees" replace />;
  }

  return <>{children}</>;
};
